import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const useArchiveSupplier = () =>
    useMutation({
        mutationFn: async (supplierId: number) => await loggedInApiCall.delete(`/api/suppliers/${supplierId}`),
    });
